const handleSearch = function() {
  const desktopContainer = document.querySelector("#search-container");
  const mobileContainer = document.querySelector("#mobile-search-container");
  const searchContent = document.querySelector("#search-content");

  const searchForm = document.querySelector("#search-form");
  const searchInput = document.querySelector("#search-input");
  const searchResults = document.querySelector("#search-results");
  const storefrontToken = window.themeSettings.storefrontToken;
  const storefrontEndpoint = `${window.location.origin}/api/2023-10/graphql.json`;
  const filters = document.querySelectorAll("#search-filters .filter");
  const suggestions = document.querySelectorAll("#search-suggestions .suggestion");

  const searchOpeners = document.querySelectorAll(".search-opener");
  const searchClosers = document.querySelectorAll(".search-closer");

  searchOpeners.forEach((obj)=>{obj.addEventListener('click',function(){document.body.classList.add('search-open');})})
  searchClosers.forEach((obj)=>{obj.addEventListener('click',function(){document.body.classList.remove('search-open');})})
  let filter = "";
  let searchTerm = ""
  let cursor = null;
  let hasNextPage = false;
  let observer;
  let isLoading = false;

  const searchMediaQuery = window.matchMedia("(max-width: 1024px)");
  const handleMediaChange = (e) => {
    if (e.matches) {
      mobileContainer.appendChild(searchContent);
    } else {
      desktopContainer.appendChild(searchContent);
    }
  };
  searchMediaQuery.onchange = handleMediaChange;
  handleMediaChange(searchMediaQuery);



  const productQuery = `
    query($query: String!, $cursor: String) {
      products(first: 10, query: $query, after: $cursor) {
        edges {
          cursor
          node {
            id
            title
            handle
            onlineStoreUrl
            collections(first: 50) {
              edges {
                node {
                  handle
                  title
                }
              }
            }
            priceRange {
              minVariantPrice {
                amount
                currencyCode
              }
            }
            featuredImage {
              url
              transformedSrc(maxWidth: 120, maxHeight: 120, crop: CENTER)
              altText
            }
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  `;

  observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting && hasNextPage) {
        searchProducts(true);
      }
    },
    { rootMargin: "100px" }
  );

  const observeLastElement = () => {
    const lastElement = document.querySelector(".search-result:last-child");

    if (lastElement && observer) {
      observer.disconnect();
      observer.observe(lastElement);
    }
  };

  async function searchProducts(loadMore = false) {
    if (isLoading) return;
    isLoading = true;

    const variables = {
      query: searchTerm,
      cursor: loadMore ? cursor : null,
    };

    const response = await fetch(storefrontEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontToken,
      },
      body: JSON.stringify({query: productQuery,variables: variables,}),
    });

    const data = await response.json();
    const products = data.data.products.edges.map(({ node }) => node);
    let filteredProducts = []
    if (filter) {
        filteredProducts = products.filter(product =>
        product.collections.edges.some(collection => collection.node.handle === filter)
      );
    }else{
      filteredProducts = products
    }

    cursor = data.data.products.edges.length
      ? data.data.products.edges[data.data.products.edges.length - 1].cursor
      : null;
    hasNextPage = data.data.products.pageInfo.hasNextPage;
    
    if (loadMore) {
      appendResults(filteredProducts);
    } else {
      displayResults(filteredProducts);
    }
    isLoading = false;
  }


  let timeout;
  searchInput.addEventListener("input", () => {
    clearTimeout(timeout);
    searchTerm = searchInput.value;
    timeout = setTimeout(async () => {
      if (searchTerm.length >= 3) {
        cursor = null;
        searchProducts();
      } else {
        searchResults.innerHTML = ""; 
      }
    }, 300);
  });

  filters.forEach((obj, i)=>{
    obj.dataset.state='inactive'
    if (i==0){
      filter = obj.dataset.filter;
      obj.dataset.state='active'
    }
    obj.addEventListener('click',function(){
      filters.forEach((f)=>{f.dataset.state='inactive'})
      filter = obj.dataset.filter;
      obj.dataset.state='active'
      searchProducts();
    })
  })
  suggestions.forEach((suggestion)=>{
    suggestion.addEventListener('click',function(){
      searchInput.value = suggestion.textContent;
      searchInput.dispatchEvent(new Event("input"));
    })
  })

const renderProductBlock = (product) => {
  const productElement = document.createElement("div");
  productElement.classList.add("search-result", "fade-in", "pad"); // Add animation class
  let catString = ``
  const productCats = product.collections.edges.map(({ node }) => node);
  productCats.forEach((collection)=>{
    const availableCats = Array.from(filters).map((el) => el.dataset.filter)
    if (availableCats.includes(collection.handle))
    catString += `<div class="product-cat">${collection.title}</div>`
  })
  productElement.innerHTML = `
    <a href="${window.location.origin}/products/${product.handle}">
      <img src="${product.featuredImage?.transformedSrc || ''}" alt="${product.title}" />
      <div>${product.title}</div>
      <div class="product-cats color__midgrey">${catString}</div>
    </a>
  `;
  return productElement
}

const appendResults = (products) => {
  requestAnimationFrame(() => {
      if (!products || products.length === 0) {
      } else {
        products.forEach((product) => {
          const productElement = renderProductBlock(product)
          productElement.classList.add("fade-out");
          searchResults.appendChild(productElement);
        });
      }
  });
  searchResults.querySelectorAll('.fade-out').forEach(function(result){result.classList.remove("fade-out");})
  if (hasNextPage) {
    observeLastElement();
  }
}

const displayResults = (products) => {
  searchResults.classList.add("fade-out");
  requestAnimationFrame(() => {
    setTimeout(() => {
      searchResults.innerHTML = "";

      if (!products || products.length === 0) {
        searchResults.innerHTML = `<p class="pad search-result results--null">No products found.</p>`;
      } else {
        products.forEach((product) => {
          const productElement = renderProductBlock(product);
          searchResults.appendChild(productElement);
        });
      }
      searchResults.classList.remove("fade-out");
      if (hasNextPage) {
        observeLastElement();
      }
    }, 200); 
  });
};

searchForm.addEventListener('submit', function(event){
  event.preventDefault()
  const activeFilter = searchContent.querySelector('.filter[data-state="active"]');
  if (activeFilter) {
    console.log('active filter', activeFilter.dataset.id, activeFilter.dataset.title)
    localStorage.setItem("selectedCollection", activeFilter.dataset.id);
    localStorage.setItem("collectionTitle", activeFilter.dataset.title);
  }
  this.submit()
})

// end search
};
